// src/components/modules/AgentApp/AppDesigner.js

import React, { useState } from 'react';
import IdeaExplorer from './IdeaExplorerView';
import ChangePipeline from './ChangePipelineView';
import { Tabs, Tab } from '@mui/material';

const AppDesigner = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h1 className="text-xl font-bold mb-4">?? App Designer</h1>
      <Tabs value={tab} onChange={handleTabChange}>
        <Tab label="Idea Explorer" />
        <Tab label="Change Pipeline" />
      </Tabs>

      {tab === 0 && <IdeaExplorer />}
      {tab === 1 && <ChangePipeline />}
    </div>
  );
};

export default AppDesigner;
